export default __webpack_public_path__ + "static/media/Pretendard-Medium.subset.c6c0fe2b.woff2";